(function() {
    'use strict';

    angular.module('plate')
        .controller('PlateCreateController', PlateCreateController);

    PlateCreateController.$inject = ['$state', 'notificationSrvc', 'plateDataSrvc', 'plateMessagesConst', 'errorNotificationSrvc'];

    function PlateCreateController($state, notificationSrvc, plateDataSrvc, plateMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            size_x: [],
            size_y: [],
            price: [],
            nonFieldErrors: []
        };
        self.plateData = {
            name: '',
            size_x: undefined,
            size_y: undefined,
            price: undefined
        };

        self.createPlate = createPlate;
        self.cleanErrors = cleanErrors;

        function createPlate() {
            plateDataSrvc.create(
                self.plateData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", plateMessagesConst.add);
                    $state.go('layout.plate.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
